<script>
import {mapGetters} from "vuex";
import {accessDeniedTooltip, hasAccess} from "@/common/permission/permission";

export default {
	props: {
		value: { type: Object, default: null },
		elements: { type: Object, default: {} },
		sessionKey: { type: String, default: "" },
	},
	data() {
		return {
			showError: false
		}
	},
	computed: {
		...mapGetters({activeSessionTabs: "session/activeTabs"}),
	},
	created() {
		this.updateActiveElementBySavedValue();
	},
	methods: {
		findElementByName(name) {
			for (let elementKey in this.elements) {
				if (this.elements[elementKey].name === name) {
					return this.elements[elementKey];
				}
			}
			return undefined;
		},
		updateActiveElementBySavedValue() {
			let savedActiveElementName = this.activeSessionTabs[this.sessionKey];
			if (this.value && this.value.name === savedActiveElementName) {
				return;
			}

			let savedActiveElement = this.findElementByName(savedActiveElementName);

			if (savedActiveElement && this.hasAccess(savedActiveElement)) {
				// if user has access to saved element use that one
				this.value = savedActiveElement;
			} else {
				// find the first element with access
				for (let elementKey in this.elements) {
					if (this.hasAccess(this.elements[elementKey])) {
						this.value = this.elements[elementKey];
						break;
					}
				}

				// if no element is accessible enforce the first
				if (!this.value) {
					this.value = this.elements[Object.keys(this.elements)[0]];
				}
			}
		},
		activateElement(element) {
			if (!this.hasAccess(element)) {
				if (this.showError) {
					this.toast(this.accessDeniedTooltip(element));
				}
				return;
			}

			this.value = element;
		},
		accessDeniedTooltip(element) {
			return accessDeniedTooltip(this.currentUser, element.permission);
		},
		hasAccess(element) {
			return hasAccess(this.currentUser, element.permission);
		}
	},
	watch: {
		value() {
			this.$store.dispatch("session/setActiveTab", { tabGroup: this.sessionKey, activeTab: this.value.name });
			this.$emit("input", this.value);
		},
		activeSessionTabs() {
			this.updateActiveElementBySavedValue();
		}

	}

};
</script>